import { IconProps } from '.'

export function HeightIcon({
  width = 14,
  height = 18,
  color = '#536063',
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      focusable='false'
      role='img'
      aria-hidden
      {...props}
      fill='none'
      viewBox='0 0 14 18'
    >
      <path
        d='M1.16667 15.6667H12.8333C13.2917 15.6667 13.6667 16.0417 13.6667 16.5001C13.6667 16.9584 13.2917 17.3334 12.8333 17.3334H1.16667C0.708336 17.3334 0.333336 16.9584 0.333336 16.5001C0.333336 16.0417 0.708336 15.6667 1.16667 15.6667ZM1.16667 0.666748H12.8333C13.2917 0.666748 13.6667 1.04175 13.6667 1.50008C13.6667 1.95841 13.2917 2.33341 12.8333 2.33341H1.16667C0.708336 2.33341 0.333336 1.95841 0.333336 1.50008C0.333336 1.04175 0.708336 0.666748 1.16667 0.666748ZM7.83334 6.50008H9.325C9.7 6.50008 9.88334 6.05008 9.61667 5.79175L7.29167 3.46675C7.125 3.30008 6.86667 3.30008 6.7 3.46675L4.375 5.79175C4.11667 6.05008 4.3 6.50008 4.675 6.50008H6.16667V11.5001H4.675C4.3 11.5001 4.11667 11.9501 4.38334 12.2084L6.70834 14.5334C6.875 14.7001 7.13334 14.7001 7.3 14.5334L9.625 12.2084C9.88334 11.9501 9.7 11.5001 9.33334 11.5001H7.83334V6.50008Z'
        fill={color}
      />
    </svg>
  )
}
